import React, { useState } from 'react';

import Button from 'components/Button';
import TitleInput from 'components/TitleInput';
import { TEXT_REGISTER } from 'constants/string/texts';
import useReloadPage from 'hooks/useReloadPage';

const ConfirmAccountInfomation = ({ form, back }) => {
  const [showPassword, setShowPassword] = useState(false);

  useReloadPage('');

  return (
    <div className="w-indicators mx-auto text-black/85">
      <fieldset>
        <TitleInput className="!mt-0 font-bold" text={TEXT_REGISTER.EMAIL_ADDRESS} required={true} />
        <p className="break-all">{form.values.email}</p>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={TEXT_REGISTER.PASSWORD} required={true}>
          <button type="button" onClick={() => setShowPassword(!showPassword)} className="ml-4">
            {showPassword ? (
              <img src={require('assets/resources/EyeVisibilityOn.svg').default} alt="eye visibility on" width={16} height={16} />
            ) : (
              <img src={require('assets/resources/EyeVisibilityOff.svg').default} alt="eye visibility off" width={16} height={16} />
            )}
          </button>
        </TitleInput>
        <div className="break-all w-100 flex flex-wrap">
          {showPassword
            ? form.values.password
            : new Array(form.values.password.length).fill('・').map((item, index) => <div key={`password-${index}`}>{item}</div>)}
        </div>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={TEXT_REGISTER.MUNICIPALITY} required={true} />
        <p className="break-all">{form.values.municipality}</p>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={TEXT_REGISTER.DEPARTMENT} required={true} />
        <p className="break-all">{form.values.department}</p>
      </fieldset>

      <Button
        onClick={() => {
          form.handleSubmit();
        }}
        className="w-60 h-9.5 mt-8 mx-auto"
        color="primary"
        type="button"
        text={TEXT_REGISTER.CREATE_ACCOUNT}
      />
      <Button onClick={back} className="w-60 h-9.5 mt-6 mx-auto" color="outline" type="button" text={TEXT_REGISTER.BACK_TO_ENTER} />
    </div>
  );
};

export default React.memo(ConfirmAccountInfomation);
